import React from 'react';
import { Heart } from 'lucide-react';

interface HeartRateZoneMeterProps {
  currentHeartRate: number;
  zones: {
    id: number;
    name: string;
    min: number;
    max: number | null;
    color: string;
    description: string;
  }[];
}

export function HeartRateZoneMeter({ currentHeartRate, zones }: HeartRateZoneMeterProps) {
  const getCurrentZone = () => {
    return zones.find(
      zone => currentHeartRate >= zone.min && (!zone.max || currentHeartRate <= zone.max)
    ) || zones[0];
  };

  const currentZone = getCurrentZone();
  const percentage = (currentHeartRate / 200) * 100; // Using 200 as max possible HR

  return (
    <div className="space-y-2">
      {/* Zone Progress Bar */}
      <div className="relative h-2 bg-muted/30 rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-muted-foreground via-primary to-destructive transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
        {zones.map((zone) => (
          <div
            key={zone.id}
            className="absolute inset-y-0 border-l border-muted-foreground/30"
            style={{ left: `${(zone.min / 200) * 100}%` }}
          />
        ))}
      </div>

      {/* Zone Labels */}
      <div className="grid grid-cols-6 gap-1">
        {zones.map((zone) => (
          <div
            key={zone.id}
            className={`text-center transition-colors ${
              zone.id === currentZone.id ? zone.color : 'text-muted-foreground'
            }`}
          >
            <div className="text-[10px] font-medium truncate">{zone.name}</div>
            <div className="text-[10px] truncate">{zone.min}+</div>
          </div>
        ))}
      </div>

      {/* Zone Description */}
      <div className={`text-xs ${currentZone.color} text-center font-medium`}>
        {currentZone.description}
      </div>
    </div>
  );
}